import type { ZodError } from 'zod';

export function getTabularErrorData(error: ZodError) {
  return Object.fromEntries(error.issues.map((issue) => [issue.path, { message: issue.message }]));
}
